import moment from 'moment';

/** Apollo DatePicker may return a Moment, Date, ISO-like string, or null. Normalize to YYYY-MM-DD for API/Yup. */
export function datePickerValueToIsoDate(v) {
  if (v == null || v === '') return '';
  if (
    typeof v?.format === 'function' &&
    typeof v?.isValid === 'function' &&
    v.isValid()
  ) {
    return v.format('YYYY-MM-DD');
  }
  if (v instanceof Date && !Number.isNaN(v.getTime())) {
    const y = v.getFullYear();
    const mo = String(v.getMonth() + 1).padStart(2, '0');
    const d = String(v.getDate()).padStart(2, '0');
    return `${y}-${mo}-${d}`;
  }
  if (typeof v === 'string') {
    const t = v.trim().slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return t;
  }
  return '';
}

/** Apollo DatePicker expects a Moment (or null), not a raw ISO string. */
export function isoDateToDatePickerValue(iso) {
  if (!iso || typeof iso !== 'string') return null;
  const m = moment(String(iso).trim().slice(0, 10), 'YYYY-MM-DD', true);
  return m.isValid() ? m : null;
}
